export default __webpack_public_path__ + "static/media/bg4.d6345620.png";